// extracted by mini-css-extract-plugin
export default {"container":"AboutYou_container__lr1NT","spacingText":"AboutYou_spacingText__i6ktr","spacingInput":"AboutYou_spacingInput__TDyYQ"};